import { Link, useNavigate } from "react-router-dom";
import withLoader from "../../components/layouts/WithLoader";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useEffect, useState } from "react";
import KPIProduitsService from "../../services/KPIProduitsService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import { Card, ListGroup, Nav, Form, Button, Tab, Col, Row, InputGroup } from 'react-bootstrap';
import SocieteService from "../../services/Societe";


// Define months options
const monthsOptions = [
  { label: "Janvier", value: 1 },
  { label: "Février", value: 2 },
  { label: "Mars", value: 3 },
  { label: "Avril", value: 4 },
  { label: "Mai", value: 5 },
  { label: "Juin", value: 6 },
  { label: "Juillet", value: 7 },
  { label: "Août", value: 8 },
  { label: "Septembre", value: 9 },
  { label: "Octobre", value: 10 },
  { label: "Novembre", value: 11 },
  { label: "Décembre", value: 12 },
];

// Generate years options for the past 20 years (or adjust as needed)
const currentYear = new Date().getFullYear();
const KPIProduits = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();

  const animatedComponents = makeAnimated();
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [dataByYear, setDataByYear] = useState([]); // to hold fetched data
  const [yearsOptions, setYearsOptions] = useState([]);
  useEffect(() => {
    SocieteService.getFinacialYearsAndMonthsFromSocieteCreationDate()
      .then((response) => {
        if (response.data["success"] !== undefined) {
          const today = new Date();
          const currentYear = today.getFullYear();

          // Setting the selected year to the current year
          setSelectedYear({
            value: currentYear,
            label: currentYear.toString(), // converting number to string for display
          });

          const yearsOptions = response.data["success"].years.map((year, index) => ({
            value: year,
            label: year.toString(), // converting number to string for display
          }));

          setYearsOptions(yearsOptions);
        }
      })
      .catch((error) => {
        console.log("error: " + error);
      });
  }, []);

  useEffect(() => {
    const currentMonth = new Date().getMonth() + 1; // Months are 0-based
    setSelectedMonth(monthsOptions.find((month) => month.value === currentMonth));
  }, []);

  const handleMonthChange = (selectedOption) => setSelectedMonth(selectedOption);
  const handleYearChange = (selectedOption) => setSelectedYear(selectedOption);

  const fetchData = () => {
    if (!selectedMonth || !selectedYear) return; // Don't fetch data if month or year is not selected

    setDataByYear({})
    startLoading();
    KPIProduitsService.getTopThreeFamilleAndSousFamilleAndCategoriesAndMarquesAndPack(
      getCurrentUserId(),
      selectedMonth.value,
      selectedYear.value
    )
      .then((response) => {
        setDataByYear(response.data.success);

        // Render status based on response data
        const isComplete = response?.data?.status?.complete;
        const isAttendComplete = response?.data?.status?.attend;

        // If the response is "complete" and "attend" is complete, stop the loader
        // if (isComplete && isAttendComplete) {
        //   stopLoading();
        // }
      })
      .catch((error) => {
        console.log("Error fetching data: ", error);
        stopLoading(); // Stop loader in case of error as well
      }).finally(() => {
        stopLoading(); // Stop loader in case of error as well
      });
  };


  useEffect(() => {
    if (dataByYear.length === 0) {
      fetchData();
    }
  }, [selectedMonth, selectedYear]); // Re-fetch data when selectedMonth or selectedYear changes


  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/" style={{ color: "black" }}>Home</Link>
                </li>
                <li className="breadcrumb-item active" style={{ color: "black" }}>
                  Les KPI de Vente
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div className="card">
                {/* <div className="card-header">
                  <h3 className="card-title">Choisir un an et un mois</h3>
                 </div> */}
                <div className="card-body d-flex justify-content-center align-items-center">
                  <div className="form-group col-6 col-sm-6">
                    <label>Choisir l'année</label>
                    <Select
                      value={selectedYear}
                      defaultValue={selectedYear}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      options={yearsOptions}
                      onChange={handleYearChange}
                      placeholder="Sélectionner l'année"
                    />
                  </div>

                  <div className="form-group col-6 col-sm-6">
                    <label>Choisir le mois</label>
                    <Select
                      value={selectedMonth}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      options={monthsOptions}
                      onChange={handleMonthChange}
                      placeholder="Sélectionner le mois"
                    />
                  </div>
                </div>

                {/*<div className="card-footer">
                  <button
                    type="button"
                    onClick={fetchData}
                    className="btn btn-dark float-right"
                  >
                    Valider
                  </button>
  </div>*/}
              </div>
              <div className="card-footer">
                <div className="col-sm-12  text-center">
                  <button
                    className="btn btn-dark"
                    onClick={fetchData}
                  >
                    Valider le choix
                  </button>
                </div>
              </div>

              {Array.isArray(dataByYear) && dataByYear.map((data, index) => (
                <div className="container mt-3 col-12 " key={index}>
                  <div className="card-header flex justify-between mb-3">
                    <h3 className="card-title">
                      {dataByYear[index]?.name?.charAt(0).toUpperCase() + dataByYear[index]?.name?.slice(1)}
                    </h3>

                    <button
                      type="button"
                      className="btn btn-dark float-right"
                      onClick={() => navigate(dataByYear[index].name === "famille" ? "/KPIProduitsDetails/FAM" : dataByYear[index].name === "sousFamille" ? "/KPIProduitsDetails/SUB_FAM" : dataByYear[index].name === "categorie" ? "/KPIProduitsDetails/CAT" : dataByYear[index].name === "brand" ? "/KPIProduitsDetails/BRAND" : dataByYear[index].name === "pack" ? "/KPIProduitsDetails/PACK" : "")}
                    >
                      Voir plus
                    </button>
                  </div>
                  <Row>
                    {
                      Object.entries(data.list).map(([userIndex, user], index) => (
                        <Col lg={4} md={4} key={user.id || userIndex}>
                          <Card className="mb-3">
                            <Card.Body className="text-center">

                              <div className="profile-user-img img-fluid img-circle mb-2 bg-info d-flex " style={{ width: "108px", height: "108px", justifyContent: "center", alignItems: "center" }}> <h3>{index + 1}</h3></div>
                              <h3 className="profile-username">{(user.sku || user.barcode) && `${user.sku || user.barcode}-`}{user.name}</h3>
                              <p className="text-muted">{userIndex}</p>
                              <ListGroup variant="flush">
                                <ListGroup.Item>
                                  <div className="d-flex justify-content-between">
                                    <strong>Commande</strong>
                                    <span>{user.count}</span>
                                  </div>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                  <div className="d-flex justify-content-between">
                                    <strong>Quantité Totale</strong>
                                    <span>{user.total_quantity}</span>
                                  </div>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                  <div className="d-flex justify-content-between">
                                    <strong>Prix initial</strong>
                                    <span>{user.totalAmountInitialPrice} DT</span>
                                  </div>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                  <div className="d-flex justify-content-between">
                                    <strong>Prix de vente</strong>
                                    <span>{user.totalAmountSellingPrice} DT</span>
                                  </div>
                                </ListGroup.Item>
                              </ListGroup>

                              {/*<Button variant="primary" block className="mt-2 w-75 bg-info">
                                <b>Lire la suite</b>
                      </Button>*/}
                            </Card.Body>
                          </Card>
                        </Col>
                      ))}
                  </Row>
                </div>
              ))}

            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default withLoader(KPIProduits);
